"use client";

import * as React from "react";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardFooter } from "@/components/ui/card";
const testimonials = [{
  quote: "The perfect balance of a high-end hotel and the comfort of home. The Wi-Fi was flawless, and the location made my morning commute effortless.",
  name: "Sarah J.",
  badge: "Business Traveler"
}, {
  quote: "After long days on site, coming back to a clean, fully furnished space was exactly what the team needed. Reliable and hassle-free booking.",
  name: "Mark T.",
  badge: "Contractor"
}, {
  quote: "Our family stay was exceptional. The attention to detail and modern amenities provided a true sanctuary in the city. Highly recommended.",
  name: "Elena R.",
  badge: "Leisure Guest"
}];
export default function GuestSuccessStories() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="guest-success-stories" className="bg-background py-32 md:py-48 overflow-hidden">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        
        {}
        <div ref={headerRef} className={cn("flex flex-col items-center justify-center mb-24 transition-all duration-800 ease-[cubic-bezier(0.16,1,0.3,1)]", isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[30px]")}>
          <h2 className="font-default text-[clamp(2rem,5vw,3.5rem)] font-normal tracking-tight leading-[1.2] text-foreground flex flex-col">
            <span className="translate-x-8 md:translate-x-12">Guest</span>
            <span>Success Stories</span>
          </h2>
        </div>

        {}
        <div ref={gridRef} className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {testimonials.map((item, i) => <div key={i} data-index={i} className={cn("transition-all duration-800 ease-[cubic-bezier(0.16,1,0.3,1)]", isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[30px]")} style={{
          transitionDelay: `${i * 100}ms`
        }}>
              <Card className="relative bg-background border-0 border-b border-b-secondary rounded-md pt-10 pb-8 px-6 h-full flex flex-col justify-between">
                
                {}
                {(i === 0 || i === testimonials.length - 1) && <div className="absolute top-0 left-0 w-5 h-5 border-t-2 border-l-2 border-secondary" aria-hidden="true" />}

                <CardContent className="p-0 flex-grow">
                  <p className="font-sans text-lg font-light tracking-[0.01em] leading-[1.6] text-foreground">
                    "{item.quote}"
                  </p>
                </CardContent>
                
                <CardFooter className="p-0 mt-12 flex flex-col items-start gap-3">
                  <span className="font-mono text-xs font-semibold tracking-[0.15em] uppercase text-foreground">
                    {item.name}
                  </span>
                  <span className="font-mono text-[10px] font-semibold tracking-[0.15em] uppercase bg-muted px-3 py-1.5 rounded-lg text-foreground">
                    {item.badge}
                  </span>
                </CardFooter>
              </Card>
            </div>)}
        </div>

      </div>
    </section>;
}